import { createSlice, createAction } from '@reduxjs/toolkit';
import { IState } from 'shared/interfaces/state.interface';
import { initialStore } from '../initial-store';

export const getAllProductVariations = createAction(
  'productVariations/getAllProductVariations',
  (payload) => ({
    payload
  })
);

// Slices

const productVatiationsSlice = createSlice({
  name: 'productVariations',
  initialState: initialStore.productVariations,
  reducers: {
    setProductVariationData: (state, { payload }) => {
      state.allProducts = payload.productVariations;
      state.count = payload.count;
      state.isLoading = false;
    },
    getAllProductVariations: (state) => {
      state.isLoading = true;
    },
    getProductVariationFail: (state) => {
      state.isLoading = false;
    }
  }
});
export const { setProductVariationData, getProductVariationFail } =
  productVatiationsSlice.actions;
export const { reducer } = productVatiationsSlice;

// Selectors
export const getProductVariationSelector = (state: IState) =>
  state && state.productVariations.allProducts;

export const getProductVariationLoadingSelector = (state: IState) =>
  state && state.productVariations.isLoading;
